const AuditGradeTest = () => import('../pages/audit_logging/AuditGradeTest.vue');
// const AuditTabs = () => import('../pages/audit_logging/AuditTabs.vue');
const CreditPage = () => import('../pages/audit_logging/CreditPage.vue');
const DeratePage = () => import('../pages/audit_logging/DeratePage.vue');
const AuditReceivable = () => import('../pages/audit_logging/AuditReceivable.vue');
const AuditCostOfWork = () => import('../pages/audit_logging/AuditCostOfWork.vue');
const PartyMembershipDues = () => import('../pages/audit_logging/PartyMembershipDues.vue');
const AuditDonation = () => import('../pages/audit_logging/AuditDonation.vue');
const AuditTuition = () => import('../pages/audit_logging/AuditTuition.vue');
const LoansApproval = () => import('../pages/audit_logging/LoansApproval.vue');
const TransactionInfoReview = () => import('../pages/audit_logging/TransactionInfoReview.vue');
const InvoiceApplicate = () => import('../pages/audit_logging/InvoiceApplicate.vue');

export default [{
	// 贷款
	path: '/CreditPage',
	name: 'CreditPage',
	component: CreditPage,
},
{
	// 减免
	path: '/DeratePage',
	name: 'DeratePage',
	component: DeratePage,
},
{
	// 贷款申请审核
	path: '/LoansApproval',
	name: 'LoansApproval',
	component: LoansApproval,
},
{
	// 应收款
	path: '/AuditReceivable',
	name: 'AuditReceivable',
	component: AuditReceivable,
},
{
	// 审核-等级考试
	path: '/AuditGradeTest',
	name: 'AuditGradeTest',
	component: AuditGradeTest,
},
{
	// 审核-工本费
	path: '/AuditCostOfWork',
	name: 'AuditCostOfWork',
	component: AuditCostOfWork,
},
{
	// 审核-党费
	path: '/PartyMembershipDues',
	name: 'PartyMembershipDues',
	component: PartyMembershipDues,
},
{
	// 审核-捐款
	path: '/AuditDonation',
	name: 'AuditDonation',
	component: AuditDonation,
},
{
	// 审核-学费
	path: '/AuditTuition',
	name: 'AuditTuition',
	component: AuditTuition,
},
{
	// 审核-学生异动信息
	path: '/TransactionInfoReview',
	name: 'TransactionInfoReview',
	component: TransactionInfoReview,
},
{
	// 审核-开票申请审核
	path: '/InvoiceApplicate',
	name: 'InvoiceApplicate',
	component: InvoiceApplicate,
},
];
